module.exports = __webpack_public_path__ + "static/media/login.1fa429e1.svg";